/**
 * Axios Singleton Instance
 * Centralized axios configuration for the entire application
 */

import axios from 'axios';
import API_CONFIG from '../config/api.config';
import {
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  responseErrorInterceptor,
} from './interceptors';

/**
 * Create axios instance with base configuration
 */
const axiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS,
});

/**
 * Apply request interceptors
 */
axiosInstance.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);

/**
 * Apply response interceptors
 */
axiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

/**
 * Export configured axios instance
 * Usage: import api from '@/api/axios'
 */
export default axiosInstance;
